export const MediatorEventType = "RACEPAGE_DETAILS_EXPANDED";
